var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m8.553 11.36.896-2.863"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8.01 13.429H8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.5,
    d: "m25.216 21.78.002.015c.1.66-.045 1.115-.275 1.394-.225.274-.62.485-1.249.485H12.995q-5.554 0-11.102.005H1.89a1.5 1.5 0 0 1-.472-.053.45.45 0 0 1-.226-.16 2.22 2.22 0 0 1-.06-2.582c.23-.324.502-.615.807-.866a4.54 4.54 0 0 0 1.666-2.906 38 38 0 0 0 .37-2.721c.227-2.473.797-4.795 1.999-6.905v-.002C7.048 5.59 8.49 4.19 10.492 3.47l.055-.02.052-.028a1.56 1.56 0 0 0 .749-.938c.261-.842.886-1.305 1.627-1.305.747 0 1.389.472 1.654 1.324l.012.036.014.035c.163.382.448.7.81.9.28.161.577.31.851.448q.135.066.258.13c.356.181.67.353.946.553zm0 0-.002-.015a1.98 1.98 0 0 0-.738-1.334m.74 1.35-.74-1.35m0 0c-1.777-1.297-2.187-3.174-2.35-4.939zm-3.59-11.082v.002c.77 1.921 1.041 3.98 1.24 6.141zm0 0c-.77-1.93-1.767-3.587-3.366-4.744zM15.548 24.353v-.001q.008-.099.006-.152a1 1 0 0 0-.156-.013 65 65 0 0 0-1.81-.004q-.467.003-.948.004H9.868q-.07 0-.117.004 0 .045.005.112c.098 1.296 1.39 2.498 2.846 2.518 1.463.02 2.824-1.165 2.946-2.468Z"
  })));
};
export default SvgBell;